<template>
  <v-popover
    class="rating-tooltip"
    offset="8"
    :placement="direction"
    trigger="hover"
    :boundary-element="boundary"
  >
    <div
      v-if="title"
      class="rating-tooltip__title"
    >
      {{ title }}
    </div>
    <Icon
      v-else
      class="rating-tooltip__icon"
      icon="ui-question-round"
      :class="{ '-active-': isShow }"
      @mouseenter.native="openPopup"
      @mouseleave.native="closePopup"
    />
    <template slot="popover">
      <div class="rating-tooltip__message">
        <slot />
      </div>
    </template>
  </v-popover>
</template>

<script>
export default {
  props: {
    direction: {
      type: String,
      default: 'left'
    },
    title: {
      type: String,
      default: null
    }
  },
  data: () => ({
    isShow: false,
    boundary: document.body
  }),
  methods: {
    openPopup() {
      this.isShow = true;
    },
    closePopup() {
      this.isShow = false;
    }
  }
};
</script>
